import { render } from "./StudbookEntryStatus.vue?vue&type=template&id=3e81d34e"
import script from "./StudbookEntryStatus.vue?vue&type=script&lang=js"
export * from "./StudbookEntryStatus.vue?vue&type=script&lang=js"

import "./StudbookEntryStatus.vue?vue&type=style&index=0&id=3e81d34e&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__